import * as firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyDZRu-8IYyV3UL1X2wHofNHUirUoHBwI7M",
  authDomain: "paystar-5084b.firebaseapp.com",
  databaseURL: "https://paystar-5084b.firebaseio.com",
  projectId: "paystar-5084b",
  storageBucket: "paystar-5084b.appspot.com",
  messagingSenderId: "141233907608",
  appId: "1:141233907608:web:d3dccbbca827d671286ded",
  measurementId: "G-5FYDJY75EZ",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const DataBase = firebase.database();
